import { render } from "./NewsDetails.vue?vue&type=template&id=44d5641e"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"

import "./NewsDetails.vue?vue&type=style&index=0&id=44d5641e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__